var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOnline)?_c('h4',{staticClass:"disconnected_message center_text pa4"},[_vm._v("\n  Please connect to"),_c('br'),_vm._v("internet to use HiHello\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }